var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.addClasses},[(_vm.item.hasResult)?_c('span',[_vm._v(_vm._s(_vm.getTranslation('CANDIDATE_' + _vm.item.result.status)))]):_c('span',[_vm._v(_vm._s(_vm.getTranslation('CANDIDATE_NOTCOME')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }